import { render, staticRenderFns } from "./GoogleTranslate.vue?vue&type=template&id=3951fec7&scoped=true&"
import script from "./GoogleTranslate.vue?vue&type=script&lang=js&"
export * from "./GoogleTranslate.vue?vue&type=script&lang=js&"
import style0 from "./GoogleTranslate.vue?vue&type=style&index=0&id=3951fec7&prod&scoped=true&lang=css&"
import style1 from "./GoogleTranslate.vue?vue&type=style&index=1&id=3951fec7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951fec7",
  null
  
)

export default component.exports